/*
 * @Author: hjb
 * @Date: 2021-04-21 10:58:58
 * @LastEditTime: 2021-04-25 15:58:45
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\sendToStudio\sendToStudio.js
 * @Description: 发送模块
 */

'use strict';
angular.module('sendToStudioModule', []).controller('sendToStudioCtrl', [
    '$scope',
    '$modalInstance',
    'editingCenterIMApiService',
    'params',
    'modalDialog',
    '$q',
    '$sessionStorage',
    function ($scope, $modalInstance, editingCenterIMApiService, params, modalDialog, $q, $sessionStorage) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                switchtdatas: [
                    {
                        name: '最近',
                        value: '1',
                    },
                    {
                        name: '同事',
                        value: '2',
                    },
                    {
                        name: '工作室',
                        value: '3',
                    },
                ],
                userItems: [],
                studioItems: [],
                lastItems: [],
                userData: [],
                studioData: [],
                userSelectedArray: [],
                studioSelectedArray: [],
                userTotal: 0,
                studioTotal: 0,
                userCurPage: 1,
                groupCurPage: 1
            };
            $scope.status = {
                switchCur: '1',
                isSearch: false
            };
            $scope.userParams = {
                trueName: '',
                userName: '',
                CURRPAGE: 1,
                PAGESIZE: 20
            };
            $scope.groupParams = {
                keyWord: '',
                CURRPAGE: 1,
                PAGESIZE: 20
            };
            $scope.lastChatParams = {
                accountId: $sessionStorage.get('curUserInfo').ID
            };
        }

        /**
         * [initData description]初始化数据
         * @return  {[type]}          [return description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData description]请求数据
         * @return  {[type]}  [return description]
         */
        function requestData() {
            getLastChatData($scope.lastChatParams).then((data) => {
                if (data.datas && data.datas.length) {
                    dealLastChat(data.datas);
                }
            });
        }

        /**
         * [dealLastChat 处理最近聊天数据]
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function dealLastChat(data) {
            $scope.data.lastItems = data.map((item) => {
                if (item.chattype === 'GROUP_CHAT') { // 最近联系人是群组
                    return {
                        icon: item.togroupfaceurl || './static/IM_group_head.png',
                        isStudio: '1',
                        name: item.togroupname,
                        id: item.togroupid,
                    };
                } else {
                    return { // 最近联系人是个人账号
                        icon: item.accountfaceurl || './static/IM_person_head.png',
                        isStudio: '0',
                        name: item.accountname,
                        id: item.accountchattype === 1 ? item.toaccountid : item.fromaccountid, // 0表示当前账户是消息的接收者，1表示当前账户是消息的发送者
                        // accountchattype: item.accountchattype // 0表示当前账户是消息的接收者，1表示当前账户是消息的发送者
                    };
                }
            });
        }

        /**
         * [swtchTab description] 切换分类
         * @param   {[object]}  item  [item description] 分类信息
         * @return  {[type]}          [return description]
         */
        $scope.swtchTab = function (item) {
            $scope.status.switchCur = item.value;
            if ($scope.status.switchCur === '1') {
                if (!$scope.data.lastItems.length) {
                    getLastChatData($scope.lastChatParams).then((data) => {
                        if (data.datas && data.datas.length) {
                            dealLastChat(data.datas);
                        }
                    });
                }
            } else if ($scope.status.switchCur === '2') {
                if (!$scope.data.userItems.length) {
                    getUserData($scope.userParams).then((data) => {
                        $scope.data.userItems = dealUserData(data);
                        if ($scope.userParams.CURRPAGE === 1 && !$scope.status.isSearch) {
                            $scope.data.userTotal = data.PAGER.ITEMCOUNT;
                        }
                    });
                }
            } else if ($scope.status.switchCur === '3') {
                if (!$scope.data.studioItems.length) {
                    getStudioData($scope.groupParams).then((data) => {
                        $scope.data.studioItems = dealStudioData(data);
                        if ($scope.groupParams.CURRPAGE === 1 && !$scope.status.isSearch) {
                            $scope.data.studioTotal = data.PAGER.ITEMCOUNT;
                        }
                    });
                }
            }
        };

        /**
         * [dealUserData 用户信息转换]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealUserData(data) {
            return data.DATA.map((item) => ({
                icon: item.FACEURL || './static/IM_person_head.png',
                isStudio: '0',
                name: item.TRUENAME,
                id: item.USERID,
            }));
        }

        /**
         * [dealStudioData 工作室信息转换]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return descriptin]
         */
        function dealStudioData(data) {
            return data.DATA.map((item) => ({
                icon: item.FACEURL || './static/IM_group_head.png',
                isStudio: '1',
                name: item.STUDIONAME,
                num: item.USERCOUNT,
                id: item.GROUPID
            }));
        }

        /**
         * [getUserData 获取用户列表]
         * @param   {[type]}  params  [params description]
         * @return  {[type]}          [return description]
         */
        function getUserData(params) {
            const defer = $q.defer();
            $scope.loadingPromise = editingCenterIMApiService.getUserList(params).then((data) => {
                if (data.DATA) {
                    defer.resolve(data);
                }
            });
            return defer.promise;
        }

        /**
         * [getStudioData 获取工作室列表]
         * @param   {[type]}  params  [params description]
         * @return  {[type]}          [return description]
         */
        function getStudioData(params) {
            const defer = $q.defer();
            $scope.loadingPromise = editingCenterIMApiService.getGroupList(params).then((data) => {
                if (data.DATA) {
                    defer.resolve(data);
                }
            });
            return defer.promise;
        }

        /**
         * [getLastChatData 获取最近聊天记录]
         * @param   {[type]}  params  [params description]
         * @return  {[type]}          [return description]
         */
        function getLastChatData(params) {
            const defer = $q.defer();
            $scope.loadingPromise = editingCenterIMApiService.getlastChatList(params).then((data) => {
                if (data.datas) {
                    defer.resolve(data);
                }
            });
            return defer.promise;
        }

        $scope.close = function () {
            $modalInstance.dismiss();
        };
        $scope.select = function (item) {
            if (item.isStudio === '0') {
                select($scope.data.userSelectedArray, item);
            } else {
                select($scope.data.studioSelectedArray, item);
            }
        };

        $scope.isSelect = function (item) {
            if (item.isStudio === '0') {
                return isSelect($scope.data.userSelectedArray, item);
            } else {
                return isSelect($scope.data.studioSelectedArray, item);
            }
        };

        /**
         * [select 选中或取消选中]
         * @param   {[type]}  arr   [arr description]
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function select(arr, item) {
            if (arr.indexOf(item) < 0) {
                arr.push(item);
            } else {
                arr.splice(arr.indexOf(item), 1);
            }
        }

        /**
         * [isSelect 是否选中]
         * @param   {[type]}  arr   [arr description]
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function isSelect(arr, item) {
            let newArr = [];
            newArr = arr.filter((obj) => obj.id === item.id);
            return newArr.length > 0;
        }

        $scope.confirm = function () {
            let sendParams = angular.copy(params);
            sendParams = angular.extend(sendParams, {
                toAccountIds: $scope.data.userSelectedArray.filter((_item) => _item.isStudio === '0').map((item) => item.id),
                toGroupIds: $scope.data.studioSelectedArray.filter((_item) => _item.isStudio === '1').map((item) => item.id)
            });
            $scope.loadingPromise = editingCenterIMApiService.send(sendParams).then((data) => {
                if (data.code === '200') {
                    modalDialog.alertType('', '发送成功', 'success', false);
                    $modalInstance.close({
                        ISSUCCESS: 'true',
                    });
                }
            }, (data) => {
                let msg = data.msg || '发送失败';
                modalDialog.alertType('', msg, 'warning', false);
            });
        };

        /**
         * [markKeyword description]
         * @param   {[type]}  word  [word description]
         * @return  {[type]}        [return description]
         */
        function markKeyword(word){
            // eslint-disable-next-line quotes
            let transformWord = word.replace($scope.keywords, (keyWord) => `<span class="key-text">${keyWord}</span>`);
            return transformWord;
        }

        /**
         * [fullTextSearch description] 检索
         * @param   {[object]}  ev  [ev description] 事件对象
         * @return  {[type]}        [return description]
         */
        $scope.fullTextSearch = function (ev) {
            if (!$scope.keywords) {
                $scope.status.isSearch = false;
                return;
            }
            if ((ev && ev.keyCode === 13) || !ev) {
                $scope.status.isSearch = true;
                $scope.userParams.trueName = $scope.keywords;
                $scope.userParams.CURRPAGE = 1;
                $scope.groupParams.CURRPAGE = 1;
                $scope.groupParams.keyWord = $scope.keywords;
                getUserData($scope.userParams).then((data) => {
                    $scope.data.userData = data.DATA.map((item) => ({
                        icon: item.FACEURL || './static/IM_group_head.png',
                        isStudio: '0',
                        name: markKeyword(item.TRUENAME),
                        id: item.USERID,
                    }));
                });
                getStudioData($scope.groupParams).then((data) => {
                    $scope.data.studioData = data.DATA.map((item) => ({
                        icon: item.FACEURL || './static/IM_group_head.png',
                        isStudio: '1',
                        name: markKeyword(item.STUDIONAME),
                        num: item.USERCOUNT,
                        id: item.GROUPID
                    }));
                });
            }
        };

        $scope.$watch('keywords', function (newV, oldV) {
            if (oldV && !newV) {
                $scope.status.isSearch = false;
                $scope.userParams.CURRPAGE = $scope.data.userCurPage;
                $scope.groupParams.CURRPAGE = $scope.data.groupCurPage;
                $scope.userParams.trueName = $scope.keywords;
                $scope.groupParams.keyWord = $scope.keywords;
            }
        });

        $scope.listMore = function (type) {
            if (type === '2') {
                $scope.userParams.CURRPAGE++;
                $scope.data.userCurPage++;
                getUserData($scope.userParams).then((data) => {
                    $scope.data.userItems = $scope.data.userItems.concat(dealUserData(data));
                });
            } else {
                $scope.groupParams.CURRPAGE++;
                $scope.data.groupCurPage++;
                getStudioData($scope.groupParams).then((data) => {
                    $scope.data.studioItems = $scope.data.studioItems.concat(dealStudioData(data));
                });
            }
        };
    },
]);
